import { createIcon } from './create-icon'

export const Pause = createIcon({
  displayName: 'Pause',
  paths: [
    'M682.667 170.667c47.128 0 85.333 38.205 85.333 85.333v512c0 47.128-38.205 85.333-85.333 85.333s-85.333-38.205-85.333-85.333v-512c0-47.128 38.205-85.333 85.333-85.333z',
    'M341.333 170.667c47.128 0 85.333 38.205 85.333 85.333v512c0 47.128-38.205 85.333-85.333 85.333s-85.333-38.205-85.333-85.333v-512c0-47.128 38.205-85.333 85.333-85.333z'
  ]
})
